import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {FormBuilder, FormControl} from '@angular/forms';
import {ChartsSearchInterface} from '../../../../models/charts-search.interface';
import {ActivatedRoute} from '@angular/router';
import {setFormValuesFromQueryParams} from '../../../../utils/filters-utils';

@Component({
  selector: 'app-vctp-from-filter',
  templateUrl: './vctp-from-filter.component.html',
  styleUrls: ['./vctp-from-filter.component.scss']
})
export class VctpFromFilterComponent implements OnInit {

  @Input()
  years!: number[];

  @Input() set yearSelected(yearSelected:number){
    this.yearControl.setValue(this.years.find(x=>yearSelected));
  }


  searchForm = this.formBuilder.group({
    year: [''],
    member: [],
    order: ['alph']
  });

  get yearControl(): FormControl {
    return this.searchForm.get('year') as FormControl;
  }

  get memberControl(): FormControl {
    return this.searchForm.get('member') as FormControl;
  }

  get orderControl(): FormControl {
    return this.searchForm.get('order') as FormControl;
  }

  @Output()
  search: EventEmitter<ChartsSearchInterface> = new EventEmitter<ChartsSearchInterface>();

  constructor(private formBuilder: FormBuilder, private activatedRoute: ActivatedRoute) { }

  ngOnInit(): void {
    this.orderControl.setValue('alph');
    setFormValuesFromQueryParams(this.searchForm, this.activatedRoute);
  }

  handleSubmit(): void {
    const search: ChartsSearchInterface = {
      startYear: this.yearControl.value,
      member: this.memberControl.value,
      order: this.orderControl.value
    };
    this.search.emit(search);
  }

  clean(): void {
    this.yearControl.setValue(this.years[0]);
    this.memberControl.reset();
    this.orderControl.setValue('alph');
    this.search.emit({startYear: this.years[0]});
  }

}
